<template>
    <span>
        <b-button-group class="float-right">
            <b-button
                variant="primary"
                @click="confirmarNovoPagamento()"
                v-if="$temAcessoView('SGTEC-FORN-PAG-01')"
                ><i class="fa fa-plus"></i> Novo Registro de Pagamento</b-button
            >
        </b-button-group>
    </span>
</template>

<script>
export default {
    props: {
        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },
    methods: {
        inserirPagamento() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.inserirPagamento().then(response => {
                if (response) {
                    if (response.success) {
                        let pagamentoId = response.data
                        this.$store.dispatch('setRecarregar', true)
                        this.$emit('detalharPagamento', pagamentoId)
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarNovoPagamento() {
            this.$swal({
                title: 'Novo Pagamento',
                html: `Confirma a criação de um novo protocolo de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.inserirPagamento()
                }
            })
        }
    }
}
</script>
